import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { db } from '../../../firebase';
import { collection, addDoc } from 'firebase/firestore';

const AddReservationModal = ({ show, handleClose, handleSave }) => {
    const [formData, setFormData] = useState({
        date: '',
        heure: '',
        nbrPersonne: '',
        anniv: '',
        prestation: 5, // Initialisation à 5
        statut: 'soumis',
        nom: '',
        tele: '',
        typeGateau: '',
        texteGateau: '',
        ageP: '',
        email: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            // Calcul de la prestation
            let prestation = formData.prestation;
            if (parseInt(formData.nbrPersonne) > 9 || parseInt(formData.nbrPersonne) > 4 && formData.anniv=='oui') {
                prestation = prestation * formData.nbrPersonne;
            } else {
                prestation = 0;
            }
            const formattedDate = formatDate(formData.date);
            // Ajout des données dans Firestore
            const reservationData = {
                ...formData,
                prestation,
                date: formattedDate, 
            };

            const reservationRef = collection(db, 'reservation');
            const docRef = await addDoc(reservationRef, reservationData);
   

            // Appeler la fonction de mise à jour locale
            handleSave({ ...reservationData, id: docRef.id });

            // Fermer le modal après l'ajout
            handleClose();
        } catch (err) {
            console.error('Erreur lors de l’ajout de la réservation:', err);
            setError('Erreur lors de l’ajout de la réservation. Veuillez réessayer.');
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Créer une réservation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-2">
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="date"
                                        value={formData.date}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Heure</Form.Label>
                                    <Form.Control
                                        type="time"
                                        name="heure"
                                        value={formData.heure}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Nombre de personnes</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="nbrPersonne"
                                        value={formData.nbrPersonne}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Nom</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nom"
                                        value={formData.nom}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Téléphone</Form.Label>
                                    <Form.Control
                                        type="tel"
                                        name="tele"
                                        value={formData.tele}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Réservation pour anniversaire</Form.Label>
                                    <div>
                                        <Form.Check
                                            type="radio"
                                            label="Oui"
                                            name="anniv"
                                            value="oui"
                                            checked={formData.anniv === 'oui'}
                                            onChange={handleChange}
                                            className="form-check-inline"
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Non"
                                            name="anniv"
                                            value="non"
                                            checked={formData.anniv === 'non'}
                                            onChange={handleChange}
                                            className="form-check-inline"
                                        />
                                    </div>
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Quel gâteau ?</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="typeGateau"
                                        value={formData.typeGateau}
                                        onChange={handleChange}
                                    >
                                        <option value="">Sélectionner un gâteau</option>
                                        <option value="Chocolat(nutella pasta)">
                                            Chocolat(nutella pasta)
                                        </option>
                                        <option value="Fraisier">Fraisier</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Texte pour personnaliser le gâteau</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="texteGateau"
                                        value={formData.texteGateau}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Âge de la personne qui fête son anniversaire</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="ageP"
                                        value={formData.ageP}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Prestation par personne/€</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="prestation"
                                        value={formData.prestation}
                                        onChange={handleChange}
                                       
                                    />
                                </Form.Group>
                                <br />
                            </div>
                            <div className="col-md-6">
                                <Button variant="primary" type="submit" disabled={loading}>
                                    {loading ? 'Enregistrement...' : 'Ajouter'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddReservationModal;
